// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1zh37","additionalInfo":"AgreementModal_additionalInfo__2B6oZ"};